module.exports = __webpack_public_path__ + "img/人物.2f19b811.png";